import React from 'react';
import { InfoPerksContext } from '../../../../contexts';
import { floorNumberWithCommas } from '../../../Utils';
import { pkPerkProgress } from '../../../../constants/ProXtraPerks';
export var getPLCCAccrualData = function (data) {
    var _a;
    var accrualData = {};
    var year = new Date().getFullYear();
    (_a = data === null || data === void 0 ? void 0 : data.accrualData) === null || _a === void 0 ? void 0 : _a.forEach(function (accData) {
        if (accData.year === year)
            accrualData = accData;
    });
    return accrualData;
};
export var getPreYearData = function (unclaimedPreYearPerks) {
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < unclaimedPreYearPerks.length; i++) {
        // eslint-disable-next-line no-param-reassign
        unclaimedPreYearPerks[i].tierPerks = [unclaimedPreYearPerks[i]];
    }
    return unclaimedPreYearPerks;
};
export var getPreviousYearData = function (data) {
    var preYearPerk = [];
    var unclaimedPreYearPerks = [];
    var tierPerks = [];
    tierPerks.length = 0;
    if (data && data.previousYearPerks) {
        unclaimedPreYearPerks = data.previousYearPerks.filter(function (perk) { return perk.perkStatus === 'UNCLAIMED'; });
        preYearPerk = getPreYearData(unclaimedPreYearPerks);
    }
    return preYearPerk;
};
export var getFilterData = function (data) {
    var tiers = [];
    var filterData = [];
    if (data && data.program && data.program.tiers) {
        tiers = data.program.tiers;
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, tiers_1 = tiers; _i < tiers_1.length; _i++) {
            var tier = tiers_1[_i];
            if (data.nextTierId !== tier.tierId) {
                filterData.push(tier);
            }
            else {
                filterData.push(tier);
                break;
            }
        }
    }
    return filterData;
};
export var getCurrentDataIndex = function (data) {
    var filterData = getFilterData(data);
    var isUnclaimed = function (item) { var _a, _b; return ((_b = (_a = item === null || item === void 0 ? void 0 : item.tierPerks) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.perkStatus) === 'UNCLAIMED'; };
    var isCurrentTier = function (item) { return item === null || item === void 0 ? void 0 : item.currentTier; };
    var index = filterData === null || filterData === void 0 ? void 0 : filterData.findIndex(isUnclaimed);
    // If there are no unclaimed perks, go to current tier
    if (index === -1) {
        index = (filterData === null || filterData === void 0 ? void 0 : filterData.findIndex(isCurrentTier)) || 0;
    }
    return index;
};
export var getYourPerkOptions = function (data) {
    var currentData = {};
    var preYearPerk = getPreviousYearData(data);
    var lastItem = data.program.tiers.slice(-1).pop().maxThreshold;
    if (preYearPerk.length > 0) {
        currentData = { item: preYearPerk[0] };
    }
    else if (data && data.program && data.program.tiers) {
        currentData = {
            item: data.program.tiers.find(function (tier) {
                return (tier.tierPerks[0].earned &&
                    tier.tierPerks[0].perkStatus === 'UNCLAIMED') ||
                    (!tier.earned && data.currentTierId === tier.tierId) ||
                    data.nextTierId === tier.tierId ||
                    tier.maxThreshold === lastItem;
            }),
        };
    }
    return currentData;
};
export function showTrackerDotTooltip() {
    var ttpc = 'ToolTipProgressCircle';
    var tooltip = document.querySelector("#".concat(ttpc, "-tooltip"));
    var trackerDot = document.querySelector("#".concat(ttpc, "-trigger"));
    if (tooltip && trackerDot) {
        tooltip.style.display = 'block';
        tooltip.style.display = 'block';
        var dotData = trackerDot.getBoundingClientRect();
        var tooltipData = tooltip.getBoundingClientRect();
        var dotCenterX = dotData.width / 2;
        var tooltipCenterX = tooltipData.width / 2;
        var tooltipPadding = 4;
        tooltip.style.left =
            Math.ceil(dotData.x + dotCenterX - tooltipCenterX) + 'px';
        tooltip.style.top =
            Math.ceil(dotData.y - tooltipData.height - tooltipPadding) + 'px';
        tooltip.style.visibility = 'visible';
    }
}
export function hideTrackerDotTooltip() {
    var tooltip = document.getElementById('ToolTipProgressCircle-tooltip');
    if (tooltip) {
        tooltip.style.display = 'none';
        tooltip.style.visibility = 'hidden';
    }
}
export var TrackerDotTooltip = function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var valueAmount = (perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.currentYearSpend) &&
        floorNumberWithCommas(perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.currentYearSpend, 0);
    return (React.createElement("div", { role: "tooltip", id: "ToolTipProgressCircle-tooltip" },
        React.createElement("button", { type: "button", onMouseDown: function () { return hideTrackerDotTooltip(); }, onTouchStart: function () { return hideTrackerDotTooltip(); } },
            React.createElement("p", { role: "tooltip", className: "ttpc-title" }, pkPerkProgress.spendText.currentSpend),
            React.createElement("p", { role: "tooltip", className: "ttpc-content" },
                "$",
                valueAmount || 0)),
        React.createElement("div", { className: "ttpc-arrow" },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "17", viewBox: "0 0 531.74 460.5", overflow: "visible", enableBackground: "new 0 0 531.74 460.5", xmlSpace: "preserve" },
                React.createElement("polygon", { stroke: "#000", fill: "#fff", points: "730.874,0.5 265.87,459.5 -200.866,0.5 " })))));
};
